import { AppDispatch } from "../store";
import {
  getCategories,
  getEventById,
  getFeaturedEvents,
  getUpcomingEvents,
} from "../../api/providers";
import {
  loading,
  loadingError,
  loadHomePage,
  loadEventPage,
} from "./publicEventsSlice";

export const startHomePage = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(loading());

    const upcomingEvents = await getUpcomingEvents();
    if (!upcomingEvents.ok)
      return dispatch(
        loadingError({ errorMessage: upcomingEvents.errorMessage.error })
      );

    const categories = await getCategories();
    if (!categories.ok)
      return dispatch(
        loadingError({ errorMessage: categories.errorMessage.error })
      );

    const featuredEvents = await getFeaturedEvents();
    if (!featuredEvents.ok)
      return dispatch(
        loadingError({ errorMessage: featuredEvents.errorMessage.error })
      );

    const payload = {
      categories: categories.categories,
      upcomingEvents: upcomingEvents.upcomingEvents,
      featuredEvents: featuredEvents.featuredEvents,
    };

    dispatch(loadHomePage(payload));
  };
};

export const startEventPage = (
  id: number,
  setLoading: (loading: boolean) => void
) => {
  return async (dispatch: AppDispatch) => {
    setLoading(true);

    const eventData = await getEventById(id);
    if (!eventData.ok) {
      setLoading(false);
      return dispatch(
        loadingError({ errorMessage: eventData.errorMessage.error })
      );
    }

    dispatch(loadEventPage(eventData));

    setLoading(false);
  };
};
